<pp-spinner [ppInput]="true" [ppHidden]="!ppUpdating"></pp-spinner>

@if (ppShowClearBtn && !ppUpdating && ppFilled) {
  <pp-icon
    [ppSVG]="iconMap[EIconPath.ICON_CLOSE_14]"
    ppColor="grey-600"
    class="saveIndicator__clear"
    [class.saveIndicator__clear--visible]="ppFocused"
    ppClass="setSize14"
    (click)="action($event)"
    aria-label="clear"
    (mousedown)="ppMouseDownHandler ? action($event) : preventMouseDownDefault($event)"
  />
}
